<template>
  <div class="login-form">
    <div class="login-box">
      <img :src="'https://www.biqs.cn/img/revolution/4m.jpg'" style="height: 100%; flex-shrink: 0" />
      <div class="login-input">
        <img :src="logoImg" />
        <span class="title"> BIQS “流程管理” </span>
        <el-form
          :model="dataForm"
          :rules="dataRule"
          size="medium"
          ref="dataForm"
          @keyup.enter.native="dataFormSubmit()"
          style="width: 356px; margin-top: 4vh"
        >
          <el-col :span="24">
            <el-form-item prop="mobilePhone">
              <el-input
                v-model="dataForm.mobilePhone"
                style="width: 100%"
                placeholder="帐号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="password">
              <el-input
                v-model="dataForm.password"
                style="width: 100%"
                type="password"
                placeholder="密码"
                show-password
              ></el-input>
            </el-form-item>
          </el-col>
          <el-button
            class="login-btn-submit"
            type="primary"
            style="width: 100%"
            @click="login()"
            :loading="isHttpLoading"
          >
            登录
          </el-button>
        </el-form>
        <p class="text-center">
          Powered by <a href="https://www.biqs.cn" style="color:rgba(0, 0, 0, 0.45)" target="_blank">BIQS.cn</a>
          &copy; 2022
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { SystemController } from "@/api";
import { mapMutations } from "vuex";
import projectConfig from "@/core/config";
import { setToken } from "@/utils";

export default {
  data() {
    return {
      bkImg: require("@/assets/img/login.png"),
      logoImg: require("@/assets/img/logo_light.png"),
      dataForm: {
        mobilePhone: null,
        password: null,
      },
      dataRule: {
        mobilePhone: [
          { required: true, message: "帐号不能为空", trigger: "blur" },
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
        ],
      },
      projectName: projectConfig.projectName,
    };
  },
  methods: {

    login() {
      let params = {
        username: this.dataForm.mobilePhone,
        password: this.dataForm.password
      };

      SystemController.login(this, params, null, { showMask: false })
        .then((datal) => {
          setToken('Bearer ' + datal.value.token);
          if(datal.success){

            SystemController.initLogin(this, null, null, { showMask: false })
              .then((data) => {
                this.setMenuList(data.data.menuList);
                delete data.data.menuList;
                this.setUserInfo(data.data);
                setToken(data.data.tokenData);
                this.setCurrentMenuId(null);
                this.$router.replace({ name: "main" });
              }).catch((e) => {});
          }
        })
        .catch((e) => {});
    },
    ...mapMutations(["setUserInfo", "setMenuList", "setCurrentMenuId"]),
  },
  mounted() {
    this.setMenuList([]);
    this.setUserInfo({});
    setToken();
  },
};
</script>

<style lang="scss">
.login-form {
  width: 100vw;
  height: 100vh;
  background: #292d36;
  display: flex;
  justify-content: center;
  align-items: center;
  .login-box {
    display: flex;
    align-items: center;
    height: 70vh;
    padding: 7vh;
    border-radius: 3px;
    background: white;
    .login-input {
      height: 100%;
      width: 420px;
      display: flex;
      align-items: center;
      flex-direction: column;
      img {
        width: 86px;
      }
      .title {
        margin-top: 2vh;
        font-size: 33px;
        color: rgba(0, 0, 0, 0.85);
        font-family: "Myriad Pro", "Helvetica Neue", Arial, Helvetica,
          sans-serif;
        font-weight: 600;
        position: relative;
        vertical-align: middle;
      }
    }
  }
}

.login-form .el-input__inner {
  height: 45px !important;
}

.login-form .el-button {
  height: 45px !important;
  font-size: 20px;
}

.text-center{
  text-align: center!important;
  color: rgba(0, 0, 0, 0.45);
}
</style>
